import { render, staticRenderFns } from "./BarChartDisplay.vue?vue&type=template&id=1492d966&"
import script from "./BarChartDisplay.vue?vue&type=script&lang=js&"
export * from "./BarChartDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports